// src/components/common/ScrollToTop.jsx

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Browser ka automatic scroll restore completely band karo
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Route change pe scroll
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Browser back/forward arrow (popstate) pe scroll
  useEffect(() => {
    const onPop = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return null;
}